/** @owner @Appboy/ai-decisioning-experience */

import { isDecisioningStudioCampaign } from "./isDecisioningStudioCampaign";
import type { DecisioningStudioCampaignContext } from "./types";

/**
 * @param messagesContext - The current messages context, if any
 * @return Liquid options to pass as `excludedOptions` for DS-linked campaign composers
 */
export const getDecisioningStudioLiquidExcludedOptions = (
  messagesContext: DecisioningStudioCampaignContext | null | undefined
): "API_TRIGGER_EVENT_PROPERTIES"[] => {
  if (isDecisioningStudioCampaign(messagesContext)) {
    return ["API_TRIGGER_EVENT_PROPERTIES"];
  }
  return [];
};
